import { render, staticRenderFns } from "./my_wait_receive.vue?vue&type=template&id=263501db&scoped=true"
import script from "./my_wait_receive.vue?vue&type=script&lang=js"
export * from "./my_wait_receive.vue?vue&type=script&lang=js"
import style0 from "./my_wait_receive.vue?vue&type=style&index=0&id=263501db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263501db",
  null
  
)

export default component.exports